module.exports = __webpack_public_path__ + "img/emo_30.f326a05c.png";